var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonCommunicating({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      marginTop: 3,
      overflow: "hidden"
    },
    width: "32px",
    height: "28.43px",
    viewBox: "0 0 40 40.43",
    enableBackground: "new 0 0 40 40.43",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "none",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    d: "M8.367,30.456l9.614-9.628l-7.546-7.579 l1.135-0.925l19.585,19.584L30,32.677l-2.757-2.617L8.367,30.456z M29.317,28.274L29.035,9.986l-9.017,8.979L29.317,28.274z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonCommunicating);
export default __webpack_public_path__ + "static/media/nonCommunicating.fdbdd35af9fd470e22308cb4e913cb57.svg";
export { ForwardRef as ReactComponent };